import { Link } from 'react-router-dom';

export default function DrivingAssistantBanner() {
  return (
    <section className="py-16 px-4 bg-gradient-to-br from-black via-gray-900 to-black relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-600 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="bg-gradient-to-r from-gray-900/90 to-black/90 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-yellow-600/30 shadow-2xl">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">

            {/* 左側：テキストコンテンツ */}
            <div className="flex-1 text-center lg:text-left">
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
                <div className="inline-flex items-center gap-2 bg-yellow-600/20 border border-yellow-600/50 rounded-full px-4 py-1.5">
                  <i className="ri-steering-2-line text-yellow-500 text-lg"></i>
                  <span className="text-yellow-500 text-sm font-semibold">New Service</span>
                </div>
                <div className="inline-flex items-center gap-1.5 bg-red-600/80 rounded-full px-3 py-1.5">
                  <i className="ri-gift-line text-white text-sm"></i>
                  <span className="text-white text-xs font-bold">First-time ¥2,000 OFF</span>
                </div>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                Driving Assistant
              </h2>

              <p className="text-gray-300 text-base md:text-lg mb-6 leading-relaxed">
                Rental car driving support &amp; sightseeing travel assistance<br className="hidden md:block" />
                <span className="text-yellow-500 font-semibold">※ Not a transportation business</span>
              </p>

              {/* 料金カード */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                <div className="bg-gradient-to-b from-gray-800/80 to-black/80 border border-yellow-600/40 rounded-xl px-3 py-4 text-center hover:border-yellow-500 transition-colors">
                  <div className="text-gray-400 text-xs mb-1">2 Hours</div>
                  <div className="text-yellow-400 text-2xl font-extrabold">¥15,000</div>
                  <div className="text-gray-500 text-xs mt-1">Short support</div>
                </div>
                <div className="bg-gradient-to-b from-yellow-900/40 to-black/80 border border-yellow-500 rounded-xl px-3 py-4 text-center relative">
                  <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-yellow-500 text-black text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap">Most Popular</div>
                  <div className="text-gray-400 text-xs mb-1">Half Day (4 hrs)</div>
                  <div className="text-yellow-400 text-2xl font-extrabold">¥30,000</div>
                  <div className="text-gray-500 text-xs mt-1">Perfect for sightseeing</div>
                </div>
                <div className="bg-gradient-to-b from-gray-800/80 to-black/80 border border-yellow-600/40 rounded-xl px-3 py-4 text-center hover:border-yellow-500 transition-colors">
                  <div className="text-gray-400 text-xs mb-1">Full Day (8 hrs)</div>
                  <div className="text-yellow-400 text-2xl font-extrabold">¥50,000</div>
                  <div className="text-gray-500 text-xs mt-1">All-day assist</div>
                </div>
                <div className="bg-gradient-to-b from-gray-800/80 to-black/80 border border-yellow-600/40 rounded-xl px-3 py-4 text-center hover:border-yellow-500 transition-colors">
                  <div className="text-gray-400 text-xs mb-1">Extension / 1 hr</div>
                  <div className="text-yellow-400 text-2xl font-extrabold">¥8,000</div>
                  <div className="text-gray-500 text-xs mt-1">Flexible add-on</div>
                </div>
              </div>

              {/* 注記 */}
              <p className="text-gray-500 text-xs mb-5 text-center lg:text-left">
                ※ Vehicle must be a rental car in the guest's name &nbsp;※ Third-party driving coverage &amp; unlimited liability insurance required
              </p>

              {/* 特徴リスト */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-4 mb-7">
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-shield-check-line text-yellow-500"></i>
                  <span>Safe &amp; Reliable</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-map-pin-line text-yellow-500"></i>
                  <span>Sightseeing Guide</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-global-line text-yellow-500"></i>
                  <span>English Available</span>
                </div>
                <div className="flex items-center gap-2 text-gray-300 text-sm">
                  <i className="ri-flight-takeoff-line text-yellow-500"></i>
                  <span>Airport Transfers OK</span>
                </div>
              </div>

              {/* CTAボタン */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-3">
                <Link
                  to="/driving-assistant"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black font-bold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-yellow-500/50 whitespace-nowrap"
                >
                  <span>View Details &amp; Book</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </Link>
                <Link
                  to="/driving-assistant-en"
                  className="inline-flex items-center gap-2 bg-transparent border border-yellow-600/60 hover:border-yellow-500 text-yellow-400 hover:text-yellow-300 font-semibold px-6 py-4 rounded-full transition-all duration-300 whitespace-nowrap"
                >
                  <i className="ri-global-line"></i>
                  <span>English Page</span>
                </Link>
              </div>
            </div>

            {/* 右側：イメージ */}
            <div className="flex-shrink-0 w-full lg:w-80 h-64 lg:h-96 rounded-xl overflow-hidden shadow-2xl border border-yellow-600/30">
              <img
                src="https://public.readdy.ai/ai/img_res/628d19285c7c8f2164631915429ab0c2.jpg"
                alt="ドライビングアシスタントサービス"
                className="w-full h-full object-cover object-top"
              />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
